<div class="modal locationPermission" tabindex="-1" role="dialog" [ngStyle]="{display: locationServicesOff ? 'block' : 'none' }">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <img src="../../../assets/nps-location.svg" alt="">
        </div>
        <div class="modal-body">
         <h1>{{modalTranslation['title']}}</h1>
         <p>{{modalTranslation['content']}}</p>
         <button class="continue-btn" (click)="withOutGpsAllow.emit(false)">{{modalTranslation['btnContent']}}</button>
         <a [routerLink]="" fragment="iOSInstructions">{{modalTranslation['linkContent']}}<img src="../../../../assets/polygon.svg" alt=""></a>
        </div>
      </div>
    </div>
</div>
